import { Component, OnInit, Inject } from "@angular/core";
import { TranslateService } from "@ngstack/translate";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from "@angular/material";
//import { Router } from "@angular/router";
import { PaymentService } from "src/app/services/http/business/payment/payment.service";
import { InvoiceSummaryComponent } from "src/app/pages/finance/payment/invoice-summary/invoice-summary.component";
import { StudentService } from "src/app/services/http/business/student/student.service";

@Component({
  selector: "app-placement-payment",
  templateUrl: "./placement-payment.component.html",
  styleUrls: ["./placement-payment.component.css"]
})
export class PlacementPaymentComponent implements OnInit {
  constructor(
    //private router: Router,
    private dialog: MatDialog,
    private payService: PaymentService,
    public translate: TranslateService,
    private studentService: StudentService,
    private dialogRef: MatDialogRef<PlacementPaymentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit() { }
  // pay(element:any) {
  //
  //   let payParams = {
  //     ListCouponId: [],
  //     CompanyDiscount: 0,
  //     Id: element.Id,
  //     IsStudent:true,
  //    // CompanyEncryptId:element.CompanyEncryptId
  //   };
  //   if (element.Price == 0) {
  //     this.paymentService.pay(payParams).subscribe(() => {
  //       this.dataSource = null;
  //       this.getInvoices();
  //     });
  //   } else {
  //     this.dialog.open(InvoiceSummaryComponent, {
  //       width: '98%',
  //       data: payParams
  //     })
  //       .afterClosed()
  //       .subscribe(() => {
  //
  //         // let paginatorParams={
  //         //   pageIndex:this.paginator.pageIndex,
  //         //   pageSize:this.paginator.pageSize
  //         // };
  //         // this.paginatorEvent(paginatorParams);
  //       });
  //   }
  // }
  onPayment() {

    this.dialogRef.close();
    let params={
      Id:this.data
    };
    this.studentService.getInvoiceComonSTU(params).subscribe(res => {

      let temp=res.DataList[0];
      if ((temp.Price - temp.PriceDiscount - temp.PriceSystemDiscount) <= 0) {
        this.payService.pay(this.data, 'melli').subscribe(() => {
          this.dialogRef.close();
        });
      } else {

        let command = {
          IsStudent:true,
          Id:this.data
        };
        this.dialog.open(InvoiceSummaryComponent, {
          width: '98%',
          data: command
        })
          .afterClosed()
          .subscribe(() => {
            this.dialogRef.close();
          });
      }
    });
  }

  onClose() {
    this.dialogRef.close();
  }
}
